import _extends from "reshow-runtime/es/helpers/extends";
import _objectWithoutProperties from "reshow-runtime/es/helpers/objectWithoutProperties";
import React, { Children, cloneElement } from 'react';
import { mixClass } from 'class-lib';
import SemanticUI from '../molecules/SemanticUI';

var renderChildren = function renderChildren(children, atom) {
  return Children.map(children, function (child) {
    if (!child) {
      return null;
    }

    if ('ul' === atom || 'ol' === atom) {
      child = /*#__PURE__*/cloneElement(child, {
        atom: 'li'
      });
    }

    return child;
  });
};

var List = function List(props) {
  var type = props.type,
      className = props.className,
      children = props.children,
      others = _objectWithoutProperties(props, ["type", "className", "children"]);

  var typeClass = 'list';

  if (type) {
    typeClass = type;
  }

  var classes = mixClass(className, typeClass);
  return /*#__PURE__*/React.createElement(SemanticUI, _extends({}, others, {
    className: classes
  }), renderChildren(children, props.atom));
};

export default List;